import { render, staticRenderFns } from "./ContemplationTime.vue?vue&type=template&id=56061bec&scoped=true&"
import script from "./ContemplationTime.vue?vue&type=script&lang=js&"
export * from "./ContemplationTime.vue?vue&type=script&lang=js&"
import style0 from "./ContemplationTime.vue?vue&type=style&index=0&id=56061bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56061bec",
  null
  
)

export default component.exports